import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Nav() {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className='hidden justify-between items-center h-full w-full font-pretendard font-medium md:flex'>
      <ul className='grid grid-cols-4 justify-center items-center h-full'>
        <li className='text-center'>
          <Link to='/'>홈</Link>
        </li>
        {/* <li className='text-center'>
          <Link to='/brand'>브랜드</Link>
        </li> */}
        <li className='text-left'>
          <Link to='/shop'>상품</Link>
        </li>
        <li>
          <Link to='/qna'>Q&A</Link>
        </li>
        <li className='text-center'>
          <Link to='/notice'>공지사항</Link>
        </li>
      </ul>

      <ul className='flex gap-3 h-full items-center'>
        {isAuthenticated ? (
          <>
            <li className='text-center'>
              <button onClick={handleLogout}>로그아웃</button>
            </li>
            <li className='text-center'>
              <Link to='/mypage'>마이페이지</Link>
            </li>
            <li className='text-center'>
              <Link to='/cart'>장바구니</Link>
            </li>
          </>
        ) : (
          <>
            <li className='text-center'>
              <Link to='/login'>로그인</Link>
            </li>
            <li className='text-center'>
              <Link to='/signup'>회원가입</Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}
